import { Box } from '@mui/material';
import GhostButton from '../../shared/button/GhostButton';
import PrimaryButton from '../../shared/button/PrimaryButton';
import { BodyText, Subheading } from '../../shared/typography/PrimaryTypography';

interface LoginErrorProps {
  message: string;
  handleBackClick: () => void;
}

/**
 * Displays a sign in error message within the login modal with options to return to sign in or contact support.
 * @param {string} message The error message to display to the user.
 * @param {(): void} handleBackClick Returns the user to the initial sign in step.
 * @returns {JSX.Element}
 */
const LoginError = ({ message, handleBackClick }: LoginErrorProps): JSX.Element => {
  return (
    <Box>
      <Subheading weight="Medium" color="primary" sx={{ textAlign: 'center', mb: 4 }}>
        Sign In Failed
      </Subheading>
      <BodyText sx={{ mb: 6 }}>{message}</BodyText>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 3 }}>
        <GhostButton outlined dark id="back-button" onClick={handleBackClick} sx={{ flex: 1 }}>
          Back to Sign In
        </GhostButton>
        <PrimaryButton component="a" href="/contact" sx={{ flex: 1 }}>
          Contact Us
        </PrimaryButton>
      </Box>
    </Box>
  );
};

export default LoginError;
